module.exports = __webpack_public_path__ + "static/media/pink_nebula_BK.cb7f098c.png";